module.exports = require('react/lib/update');


//////////////////
// WEBPACK FOOTER
// ./~/react-toastr/~/react-addons-update/index.js
// module id = 168
// module chunks = 0